<template>
  <div class="duplicate-breakdown">
    <div class="header">
      <div class="black--text text-body-2 font-weight-bold">
        Duplicate #{{ index }}
      </div>
      <div class="pl-4">Main Copy</div>
      <div class="pl-4">This Reference</div>
    </div>
    <field-comparison
      v-for="fieldDiff in fieldDiffs"
      :key="fieldDiff.field"
      v-bind="fieldDiff"
    />
  </div>
</template>

<script>
import FieldComparison from './FieldComparison';
import { Publication } from '@/models';
import { PublicationFieldDiffType } from '@/enums';
import { publicationDiffHelpers } from '@/modules';

const FIELD_TO_LABEL = {
  title: 'Title',
  authors: 'Authors',
  year: 'Year',
  doi: 'DOI',
  placePublished: 'Place Published',
  abstract: 'Abstract',
};

export default {
  name: 'DuplicateBreakdown',
  components: { FieldComparison },
  props: {
    index: {
      type: Number,
      required: true,
    },
    mainCopy: {
      type: Publication,
      required: true,
    },
    otherCopy: {
      type: Publication,
      required: true,
    },
    showAllFields: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldDiffs() {
      const fieldDiffs = publicationDiffHelpers
        .comparePublications(this.mainCopy, this.otherCopy)
        .map((diff) => {
          if (diff.field === 'authors') {
            diff.left = diff.left.join('; ');
            diff.right = diff.right.join('; ');
          }
          if (diff.field === 'abstract') {
            diff.expandable = true;
          }
          diff.field = FIELD_TO_LABEL[diff.field];
          return diff;
        });

      if (!this.showAllFields) {
        return fieldDiffs.filter(
          (diff) => diff.diffType !== PublicationFieldDiffType.MATCH
        );
      }

      return fieldDiffs;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.duplicate-breakdown {
  .header {
    display: grid;
    grid-template-columns: 1fr 3fr 3fr;
    font-size: 14px;
    font-weight: 500;
    padding: 0px 16px 12px 0px;
    color: map-get($grey, 'darken-2');
  }
}
</style>
